import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
});

// ✅ Request Interceptor (FIXED)
api.interceptors.request.use(
  (config) => {
    const token =
      sessionStorage.getItem("adminToken") ||
      localStorage.getItem("adminToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor (SAFE VERSION)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 🔥 Only logout if token actually exists
    const hasToken =
      sessionStorage.getItem("adminToken") ||
      localStorage.getItem("adminToken");

    if (error.response?.status === 401 && hasToken) {
      console.log("401 Unauthorized - logging out");

      sessionStorage.removeItem("adminToken");
      sessionStorage.removeItem("adminInfo");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminInfo");

      window.location.href = "/sign-in";
    }

    return Promise.reject(error);
  }
);

export default api;

/**
 * Calls a stored-procedure operation through POST /api/executeprocedure.
 *   const res = await callProc("RoleList", { page: 1, limit: 10 });
 * The result mimics what the old REST calls returned, so existing code keeps working: `res.data` is `{ success: true, ...payload }`
 * (or the payload itself when the procedure returns an array, e.g. the sidebar menus). Errors reject like any axios call, with the
 * server message in `error.response.data.message`.
 */
export const callProc = async (procName, para = {}) => {
  try {
    const res = await api.post("/api/executeprocedure", { procName, Para: para });
    const payload = res.data?.data;
    return { ...res, data: Array.isArray(payload) ? payload : { success: true, ...(payload || {}) } };
  } catch (err) {
    if (err.response?.data?.message) err.message = err.response.data.message;
    throw err;
  }
};
